import { ContextMenuItem } from 'redesign';
import { useTranslation } from 'react-i18next';
import { useGetWorkflowActionHandlers } from './use-get-workflow-actions';
import { useAlert, workflowAlerts } from '../../../../../../shared/components/alerts';

export const useGetWorkflowMenuActions = () => {
  const { alertSuccess, alertError } = useAlert();
  const { t } = useTranslation('ogp-screen-specific');

  const { handleViewWorkflow, handleArchiveWorkflow } = useGetWorkflowActionHandlers({
    archiveOptions: {
      onSuccess: () => {
        // t('workflow_archived.success_message') - this is here to generate the success message
        alertSuccess(t(workflowAlerts.success.archived));
      },
      onError: () => {
        // t('workflow_archived.error_message') - this is here to generate the error message
        alertError(t(workflowAlerts.error.archived));
      },
    },
  });
  const getMenuActions = (workflowId: string) => {
    return [
      <ContextMenuItem key={`view-${workflowId}`} onClick={() => handleViewWorkflow(workflowId)}>
        {t('workflows.table.see_detail', { ns: 'ogp-screen-specific' })}
      </ContextMenuItem>,
      <ContextMenuItem
        key={`archive-${workflowId}`}
        onClick={() => handleArchiveWorkflow(workflowId)}
      >
        {t('workflows.table.delete', { ns: 'ogp-screen-specific' })}
      </ContextMenuItem>,
    ];
  };

  return { getMenuActions };
};
